import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ItemListComponent } from './item-list/item-list.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { LightboxModule } from 'ngx-lightbox';

@NgModule({
  imports: [
    NgbModule,
    CommonModule,
    NgxDatatableModule,
    LightboxModule
  ],
  declarations: [ItemListComponent],
  entryComponents: [ItemListComponent],
  exports:[ItemListComponent]
})
export class ItemtableModule { }
